<template>
  <div>
    <div class="h-dialogContainer" >
      <template>
        <ParseForm ref="basic" :formId="formItems.basic.formId" :formParams="formItems.basic.formObj" :opCode="opCode" ></ParseForm>
      </template>
    </div>
  </div>
</template>

<script>
import ParseForm from '../../../util/parseFormNew/ParseForm';
import SubscriberTool from '../../../util/parseFormNew/tools/subscriberTool';
import ajaxUrl from "../../../data/ajaxUrl";
import { EventBus } from "../../../../../plugins/eventBus";

export default {
  name: "AddBatchPviForm",
  components: {
    ParseForm,
  }, 
  methods: {
    getDatas() {
      const map = new Map();
      if (this.$refs.basic) {
        if (!this.$refs.basic.validateResult()) {
          console.log("表单验证不通过");
          return false;
        }
        const maps = this.$refs.basic.getDatas();
        for (const [key, value] of maps.entries()) {
          map.set(key, value);
        }
      }
      console.log(map);
      return map;
    },
    getJson(ne, callback) {
      this.ne = ne;
      const params = {
        msgid: this.msgId,
        neid: ne.neid,
      };
      this.$axios.post(ajaxUrl.addpviBatchJsonReq, params).then(response => {
        if (!response) {
          console.log("getJson response error");
          return;
        }
        if (!response.data) {
          console.log("getJson response.data error");
          return;
        }
        if (!response.data.resultVal) {
          console.log("getJson response.data.resultVal error");
          return;
        }
        if (response.data.errorCode !== "0") {
          console.log("getJson response.data.errorCode error");
          callback(response);
          return;
        }
        const res = response.data.resultVal;
        const sub = new SubscriberTool();
        const resultMap = sub.$devideByGroupBy(res, []);
        this.formItems.basic.formObj = resultMap.get(this.formItems.basic.modelName);
        callback(response);
      });      
    },
    responseIsFailed(response) {
      if (!response) {
        console.log("response error");
        return true;
      }
      if (!response.data) {
        console.log("response.data error");
        return true;
      }
      if (!response.data.resultVal) {
        console.log("response.data.resultVal error");
        return true;
      }
      if (0 !== response.data.resultVal.result) {
        EventBus.$emit("toast", {
          type: "warning",
          content: response.data.errorString
        });
        return true;
      }
      return false;
    },
    async saveBatchUser(ne, callback) {
      const formData = this.getDatas();

      if (formData) { 
      const startPVI = formData.get("startPVI");
      const opCount = formData.get("count");
      const addPviList = [];
      const startPviNum =startPVI.split("@")[0];
      const startPviStr =startPVI.split("@")[1];
      let startPviNumSize = startPviNum.length; //加的数若位数小于起始数则补齐0

      for(let i=0;i<opCount;i++){
        let datai=(Number(startPviNum) + i).toString();
        let dataiSize = datai.length;
        if (dataiSize < startPviNumSize) {
          for (let z = 0; z < startPviNumSize - dataiSize; z++) {
            datai = "0" + datai; //不够的就在前面补0
          }
        }
        addPviList.push({
          pvi: datai+"@"+startPviStr
        });
      }
        this.sendAddPviList = addPviList;
        let pviEvery100 = startPviNum;
        let countAll = parseInt(formData.get("count"));
        let numAxios = parseInt(countAll / 100); //取整
        let numAxiosLast = countAll % 100; //取余数
        let countEach = 100;  
        if (numAxios > 0) {
          if (numAxiosLast == 0) {
            //整数
            for (let i = 0; i < numAxios; i++) {
              let paramsEach = {
                vo: {
                 "count": 100,
                 "startPVI": parseInt(pviEvery100) + i * 100 +"@"+ startPviStr,
                 "ki": formData.get("ki"),
                 "op": formData.get("op"),
                 "amf": formData.get("amf"),
                },
                info: {
                  msgid: this.msgId,
                  neid: ne.neid,
                }
              };

              await this.$axios
                .post(ajaxUrl.requestCommonD, paramsEach)
                .then(response => {
                  if (this.responseIsFailed(response)) {
                    this.$loading.hideLoadding();
                    return;
                  }

                  this.resultValAll = this.resultValAll.concat(
                    response.data.resultVal.resultCode
                  );
                  this.resultCodeStr = this.resultCodeStr.concat(
                    response.data.resultVal.resultCodeStr
                  );
                  if (i == numAxios - 1) {
                    response.data.resultVal.resultCode = this.resultValAll;
                    response.data.resultVal.resultCodeStr = this.resultCodeStr;

                    callback(response, this.sendAddPviList);
                  }
                });
            }
          } else {
            for (let i = 0; i <= numAxios; i++) {
              if (i == numAxios && numAxios > 0 && numAxiosLast != 0) {
                countEach = countAll - numAxios * 100; //整数部分下发后剩余部分下发
              }
              let paramsEach = {
                vo: {
                 "count": countEach,
                 "startPVI": parseInt(pviEvery100) + i * 100 +"@"+ startPviStr,
                 "ki": formData.get("ki"),
                 "op": formData.get("op"),
                 "amf": formData.get("amf"),
                },
                info: {
                  msgid: this.msgId,
                  neid: ne.neid,
                }
              };
              await this.$axios
                .post(ajaxUrl.requestCommonD, paramsEach)
                .then(response => {
                  if (this.responseIsFailed(response)) {
                    this.$loading.hideLoadding();
                    return;
                  }
                  this.resultValAll = this.resultValAll.concat(
                    response.data.resultVal.resultCode
                  );
                  this.resultCodeStr = this.resultCodeStr.concat(
                    response.data.resultVal.resultCodeStr
                  );

                  if (i == numAxios) {
                    response.data.resultVal.resultCode = this.resultValAll;
                    response.data.resultVal.resultCodeStr = this.resultCodeStr;

                    callback(response, this.sendAddPviList);
                  }
                });
            }
          }
        } else if (numAxios == 0 && numAxiosLast != 0) {//没有整数部分即不到100，全下发
        const params = { 
          vo: {    
            "startPVI": formData.get("startPVI"),
            "ki": formData.get("ki"),
            "op": formData.get("op"),
            "amf": formData.get("amf"),
            "count": parseInt(formData.get("count")),
          }, 
          info: {
            msgid: this.msgId,
            neid: ne.neid,
          }
        };
        this.$axios.post(ajaxUrl.requestCommonD, params).then((response) => { 
          if (callback) {
            callback(response,addPviList);
          }
        });}
      } 
      else{
        this.$loading.hideLoadding();
      }
    }, 
  },
  computed: {

  },
  data() {
    return {
      ne: null,
      id: 0,
      funcMap: null,
      list: [ 
      ],
      formItems: {
        basic: {
          formId: "PviAddBatchBasicInfo",
          modelName: "basic",
          formObj: null,
        },
      }, 
      opCode: "add",
      msgId: "30474",
      timer1: null,
      resultValAll: [],
      resultCodeStr: [],
      sendAddPviList: []
    };
  },
  beforeDestroy() {
  }
};
</script>
